import Cookies from 'js-cookie';
import SettingMer from '@/utils/settingMer';
import cryptoJs from 'crypto-js';
var TokenKey = 'Authori-zation';
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}

/**
 * aes 解密
 * @param {Object} res
 */
export function decryptedAes(data) {
  var textString = data;
  var key = afterCutAndappend(SettingMer.PK, '0', 32);
  var hexKey = cryptoJs.enc.Utf8.parse(key);
  var pk = decrypted(SettingMer.CODE_PK);
  var ivKey = afterCutAndappend(pk, '0', 16);
  var iv = cryptoJs.enc.Utf8.parse(ivKey);
  var decryptedWord = cryptoJs.AES.decrypt(textString, hexKey, {
    iv: iv,
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.Pkcs7
  });
  var cryptoData = decryptedWord.toString(cryptoJs.enc.Utf8);
  return cryptoData;
}

/**
 * des 加密
 * @param {Object} textString
 */
export function encrypted(word) {
  var textString = word;
  var key = afterCutAndappend(SettingMer.PK, '0', 32);
  var hexKey = cryptoJs.enc.Utf8.parse(key);
  var encrypted = cryptoJs.DES.encrypt(textString, hexKey, {
    mode: cryptoJs.mode.ECB,
    padding: cryptoJs.pad.Pkcs7
  });
  var cryptoData = cryptoJs.enc.Base64.stringify(encrypted.ciphertext);
  return cryptoData;
}

/**
 * des 解密
 * @param {Object} res
 */
export function decrypted(word) {
  var textString = cryptoJs.enc.Base64.parse(word);
  var key = afterCutAndappend(SettingMer.PK, '0', 32);
  var hexKey = cryptoJs.enc.Utf8.parse(key);
  var decrypted = cryptoJs.DES.decrypt({
    ciphertext: textString
  }, hexKey, {
    mode: cryptoJs.mode.ECB,
    padding: cryptoJs.pad.Pkcs7
  });
  var cryptoData = decrypted.toString(cryptoJs.enc.Utf8);
  return cryptoData;
}

/**
 * 字符串过长 截取 不满足追加
 * @param {Object} var textString
 * @param {Object} var append
 * @param {Object} var len
 */
export function afterCutAndappend(textString, append, len) {
  if (textString.length > len) {
    textString = textString.substring(0, len);
  } else {
    for (var i = 0; i < len; i++) {
      if (textString.length < len) {
        textString = textString + append;
      }
    }
  }
  return textString;
}
export function afterCutAndappend2(textString, append, startLen, len) {
  if (textString.length > len) {
    textString = textString.substring(startLen, startLen + len);
  } else {
    for (var i = 0; i < len; i++) {
      if (textString.length < len) {
        textString = textString + append;
      }
    }
  }
  return textString;
}